module.exports = __webpack_public_path__ + "img/ios-prompt.308b7732.png";